// Theme: copper-grid
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'copper-grid',
  name: 'COPPER GRID',
  tagline: 'COPPER GRID',
  description: 'Grade industrial em cobre queimado com acabamento metalico quente.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#1E1410', '#C9773A', '#2A1D17', '#F4E4D8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-copper-grid'
  },
  colorVars: {
    '--accent': '#C9773A',
    '--accent-foreground': '#1E1410',
    '--background': '#1E1410',
    '--border': '#5C3926',
    '--card': '#2A1D17',
    '--card-border-active': 'rgba(201, 119, 58, 0.42)',
    '--card-completed': '#2A1D17',
    '--card-foreground': '#F4E4D8',
    '--card-glow': 'rgba(201, 119, 58, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1E1410',
    '--foreground': '#F4E4D8',
    '--hold-fill': '#C9773A',
    '--input': '#2A1D17',
    '--modal-bg': '#1E1410',
    '--modal-border': '#5C3926',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.24)',
    '--muted': '#5C3926',
    '--muted-foreground': '#E8D5C7',
    '--nav-active': '#C9773A',
    '--nav-bg': '#1E1410',
    '--popover': '#2A1D17',
    '--popover-foreground': '#F4E4D8',
    '--primary': '#C9773A',
    '--primary-foreground': '#1E1410',
    '--ring': '#C9773A',
    '--secondary': '#5C3926',
    '--secondary-foreground': '#F4E4D8',
    '--streak': '#C9773A',
    '--success': '#22C55E',
    '--success-foreground': '#1E1410',
    '--xp': '#C9773A',
    '--xp-bg': '#2A1D17'
  },
  resolvedVars: {
    '--accent': '#C9773A',
    '--accent-foreground': '#1E1410',
    '--accent-foreground-hsl': '17 30% 9%',
    '--accent-foreground-oklch': 'from #1E1410 l c h',
    '--accent-hsl': '26 57% 51%',
    '--accent-oklch': 'from #C9773A l c h',
    '--background': '#1E1410',
    '--background-hsl': '17 30% 9%',
    '--background-oklch': 'from #1E1410 l c h',
    '--border': '#5C3926',
    '--border-hsl': '21 42% 25%',
    '--border-oklch': 'from #5C3926 l c h',
    '--border-w': '1px',
    '--card': '#2A1D17',
    '--card-border-active': 'rgba(201, 119, 58, 0.42)',
    '--card-completed': '#2A1D17',
    '--card-completed-hsl': '19 29% 13%',
    '--card-completed-oklch': 'from #2A1D17 l c h',
    '--card-foreground': '#F4E4D8',
    '--card-foreground-hsl': '26 56% 90%',
    '--card-foreground-oklch': 'from #F4E4D8 l c h',
    '--card-glow': 'rgba(201, 119, 58, 0.08)',
    '--card-hsl': '19 29% 13%',
    '--card-oklch': 'from #2A1D17 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1E1410',
    '--destructive-foreground-hsl': '17 30% 9%',
    '--destructive-foreground-oklch': 'from #1E1410 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#F4E4D8',
    '--foreground-hsl': '26 56% 90%',
    '--foreground-oklch': 'from #F4E4D8 l c h',
    '--hold-fill': '#C9773A',
    '--hold-fill-hsl': '26 57% 51%',
    '--hold-fill-oklch': 'from #C9773A l c h',
    '--input': '#2A1D17',
    '--input-hsl': '19 29% 13%',
    '--input-oklch': 'from #2A1D17 l c h',
    '--modal-bg': '#1E1410',
    '--modal-bg-hsl': '17 30% 9%',
    '--modal-bg-oklch': 'from #1E1410 l c h',
    '--modal-border': '#5C3926',
    '--modal-border-hsl': '21 42% 25%',
    '--modal-border-oklch': 'from #5C3926 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.24)',
    '--muted': '#5C3926',
    '--muted-foreground': '#E8D5C7',
    '--muted-foreground-hsl': '25 42% 85%',
    '--muted-foreground-oklch': 'from #E8D5C7 l c h',
    '--muted-hsl': '21 42% 25%',
    '--muted-oklch': 'from #5C3926 l c h',
    '--nav-active': '#C9773A',
    '--nav-active-hsl': '26 57% 51%',
    '--nav-active-oklch': 'from #C9773A l c h',
    '--nav-bg': '#1E1410',
    '--nav-bg-hsl': '17 30% 9%',
    '--nav-bg-oklch': 'from #1E1410 l c h',
    '--popover': '#2A1D17',
    '--popover-foreground': '#F4E4D8',
    '--popover-foreground-hsl': '26 56% 90%',
    '--popover-foreground-oklch': 'from #F4E4D8 l c h',
    '--popover-hsl': '19 29% 13%',
    '--popover-oklch': 'from #2A1D17 l c h',
    '--primary': '#C9773A',
    '--primary-foreground': '#1E1410',
    '--primary-foreground-hsl': '17 30% 9%',
    '--primary-foreground-oklch': 'from #1E1410 l c h',
    '--primary-hsl': '26 57% 51%',
    '--primary-oklch': 'from #C9773A l c h',
    '--radius': '12px',
    '--ring': '#C9773A',
    '--ring-hsl': '26 57% 51%',
    '--ring-oklch': 'from #C9773A l c h',
    '--secondary': '#5C3926',
    '--secondary-foreground': '#F4E4D8',
    '--secondary-foreground-hsl': '26 56% 90%',
    '--secondary-foreground-oklch': 'from #F4E4D8 l c h',
    '--secondary-hsl': '21 42% 25%',
    '--secondary-oklch': 'from #5C3926 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#C9773A',
    '--streak-hsl': '26 57% 51%',
    '--streak-oklch': 'from #C9773A l c h',
    '--success': '#22C55E',
    '--success-foreground': '#1E1410',
    '--success-foreground-hsl': '17 30% 9%',
    '--success-foreground-oklch': 'from #1E1410 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(26 57% 51% / 0.15)',
    '--xp': '#C9773A',
    '--xp-bg': '#2A1D17',
    '--xp-bg-hsl': '19 29% 13%',
    '--xp-bg-oklch': 'from #2A1D17 l c h',
    '--xp-hsl': '26 57% 51%',
    '--xp-oklch': 'from #C9773A l c h'
  }
}
